var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_554_2",
    transform: "matrix(0.0257143 0 0 0.02 -0.142857 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_554_2",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1UlEQVR4nO3YwQ2CQBSE4b8SxWKwRIV2FPsQqUBP6gVjstxAN9HVWZ0veSHhxGQeSwLYfyiAGuiAa7hW4X42lsAJ6Efmfr8kA4sHIYY5AnPE1U9CDLNGXBcZpEXcJTLIGXGHyCB7xFWRQVaIKyJPrRkZKMPDToXI4jsymIcjtg0HQBvWKYsmzN5kF3nUjs0WIf2LI6N3ENxIEl4txFar+ZWXfYqDqHEjatyIGjeixo2ocSNq3IgaN5Ljfy2p/119ovk4B8GNpOHVQmy1mgStbL4RxEjgBocNKrVYrW08AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.bfb07c9ab673721275e2117d5f08c471.svg";
export { ForwardRef as ReactComponent };